<template>
    <div class="mt-6 content">
        <h3 class="has-text-white"><i class="fad fa-fw fa-file-certificate mr-3"></i>Certifications & Completion Forms</h3>

        <p class="mt-6 has-text-white" v-if="!registration.id"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading certifications...</p>

        <div v-else class="mt-6 pb-6" ref="top">
            <div class="columns is-gapless has-text-white" v-if="isPreRegistation">
                <div class="column is-narrow"><i class="far fa-fw fa-info-circle mr-2"></i></div>
                <div class="column">
                    <span class="has-text-weight-bold">You have pre-registered for this conference.</span><br>Additional information for this event may be made available to you as the event approaches.
                </div>
            </div>
            <div v-else>
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
    import {client as http, apiUrl} from "../../../http_client";
    import moment from "moment";
    import UiCard from "../../../components/UiCard.vue";
    import vueSignature from "vue-signature";
    import {mapGetters} from "vuex";
    import LogSignature from "../LogSignature.vue";

    export default {
        components: {LogSignature, UiCard, vueSignature},
        props: ['registrationId'],
        data: function() {
            return {
                registration: {
                    conference: {}
                },
                logBuilder: [],
                ready: {
                    sessions: false,
                    ondemand: false,
                    log: false,
                    confirm: false
                },
                eval: {
                    q1: null,
                    q2: null,
                    q3: null,
                    q4: null,
                    q5: null,
                    comments: null
                },
                disabled: false,
                sig: null,
                totalMinutes: 0,
                totalClockHours: '0.00',
                apiUrl,
                loading: true

            };
        },
        computed: {
            ...mapGetters(['currentUser']),
            isPreRegistation: function() {
                return false;
                // return moment().isBefore(moment(this.registration.conference.start_at));
            },
            applyReady: function() {
                return this.ready.sessions && this.ready.ondemand && this.ready.log && this.ready.confirm;
            }
        },
        methods: {
            loadRegistration: function(force) {
                http.get('app/registrations/' + this.registrationId, {force}).then(response => {
                    this.registration = response.data;
                });
            },
            apply(app) {
                if (!this.loading) {
                    this.loading = true;
                    http.post('app/registrations/' + this.registrationId + '/applications', {conf_application_id: app.id}).then(response => {
                        this.registration.configs.push({
                            conf_application_id: app.id,
                            progress: 1
                        });
                        this.scrollTo('top');
                        this.loading = false;
                    });
                }
            },
            getConfApp: function(conf_app) {
                for (let i = 0; i < this.registration.applications.length; i++) {
                    const app = this.registration.applications[i];
                    if (app.conf_application_id === conf_app.id) {
                        return app;
                    }
                }
                return null;
            },
            scrollTo(refName) {
                let element = this.$refs[refName];
                if (element) {
                    element.scrollIntoView({behavior: 'smooth'});
                }
            },
        },
        mounted() {
            this.loadRegistration(true);
        }
    };
</script>

<style lang="scss" scoped>

    .log-row {
        .log-title {
            margin-top: 2px;
            font-size: 1em;
            font-weight: bold;
        }

        .log-date {
            margin-top: 5px;
            font-size: 0.8em;
        }
    }

    h4 {
        font-size: 1.2rem;
        margin-top: 1.5rem;
        margin-bottom: 2rem;
        padding-bottom: 0.8rem;

        i {
            color: #336699;
        }

        border-bottom: 1px dashed #ddd;
    }
</style>

<style lang="scss">
    .step-item {
        list-style: none;
    }

    .survey {
        .survey-radio {
            margin: 0 !important;
            padding: 0 !important;
        }
    }
</style>
